<template>
  <div class="text-left">
    <modal-title :title="title" @close="action('close', selectedItem)"/>
    <h5 class="system-name">{{ selectedItem.item.systemName }}</h5>
    <component
      v-if="allowEdit"
      :is="editorComponent"
      :id="selectedItem.item.id"
      @saved="action('update', selectedItem)"
      @canceled="action('close', selectedItem)"
    ></component>
    <form-buttons>
      <button
        v-if="allowDelete"
        type="button"
        class="btn btn-danger"
        @click="action('delete', selectedItem)"
      >
        Delete
      </button>
    </form-buttons>
  </div>
</template>
<script>
import documentModelMixin from "@/mixins/documentModel";
import ModalTitle from "@/components/common/modal/ModalTitle.vue";
import editorComponents from "./editors";
import {
  SECTION,
  TAG,
  REPEATING_CONTENT_BLOCK,
  REPEATING_TABLE_BLOCK,
  HTML_CONTENT_BLOCK,
  CONTENT_BLOCK,
} from "@/constants/contentControlTypes";
import { BUSINESS_RULE } from "@/constants/businessRule";
import { prettify } from "@/util/stringUtil";

const editors = [
  { type: BUSINESS_RULE, editor: editorComponents.BusinessRule },
  { type: SECTION, editor: editorComponents.Section },
  { type: TAG, editor: editorComponents.Default },
  { type: REPEATING_CONTENT_BLOCK, editor: editorComponents.Default },
  { type: REPEATING_TABLE_BLOCK, editor: editorComponents.Default },
  { type: CONTENT_BLOCK, editor: editorComponents.Default },
];

const action = function(action, item) {
  this.$emit("action", { action, selectedItem: item });
};

export default {
  components: { ModalTitle },
  mixins: [documentModelMixin],
  props: {
    selectedItem: {
      required: true,
    },
  },
  computed: {
    title: function() {
      const type = this.selectedItem.type;
      if (type === BUSINESS_RULE) {
        return "Display Rule";
      }

      return prettify(type);
    },
    allowEdit: function() {
      return !!editors.find((e) => e.type === this.selectedItem.type);
    },
    allowDelete: function() {
      return (
        this.selectedItem.type === SECTION ||
        this.selectedItem.type === TAG ||
        this.selectedItem.type === REPEATING_CONTENT_BLOCK ||
        this.selectedItem.type === REPEATING_TABLE_BLOCK ||
        this.selectedItem.type === HTML_CONTENT_BLOCK ||
        this.selectedItem.type === CONTENT_BLOCK ||
        (this.selectedItem.type === BUSINESS_RULE &&
          !!this.documentModel &&
          !this.documentModel.businessRuleInUse(this.selectedItem.item.id))
      );
    },
    editorComponent: function() {
      const matched = editors.find((e) => e.type === this.selectedItem.type);
      if (matched) {
        return matched.editor;
      }

      return null;
    },
  },
  methods: {
    action,
  },
  emits: ["action"],
};
</script>
<style lang="scss" scoped>
h5.system-name {
  font-weight: bold;
  margin-bottom: 15px;
}
</style>
